var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { isValidJson } from "../jsonUtil";
import { isCurrentRouteBlocked } from '../../auth/blocked-state-routes';
var LastStateService = /** @class */ (function () {
    function LastStateService($localStorage, $state, $window, $urlService) {
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$window = $window;
        this.$urlService = $urlService;
    }
    Object.defineProperty(LastStateService.prototype, "storage", {
        get: function () {
            return window.sessionStorage;
        },
        enumerable: true,
        configurable: true
    });
    LastStateService.prototype.setLastState = function (href) {
        var url = new URL(href);
        if (!url.pathname || url.pathname === '/') {
            return;
        }
        var state = this.$urlService.match({ path: url.pathname, search: url.search });
        var search = this.urlToSearchParamsObject(url);
        var lastState = state && { match: state.match, name: state.rule.state.name, search: search, href: href };
        this.storage.setItem("lastState", JSON.stringify(lastState) || href);
    };
    LastStateService.prototype.restoreLastState = function (_a) {
        var defaultStateToGo = _a.defaultStateToGo, _b = _a.forceDefaultState, forceDefaultState = _b === void 0 ? false : _b;
        if (isCurrentRouteBlocked()) {
            return;
        }
        var lastState = this.storage.getItem('lastState');
        var current = this.$state.current;
        if (lastState) {
            this.clearLastState();
            this.redirectToLastState(lastState);
        }
        else if (forceDefaultState || (!current.name && !current.abstract)) {
            this.$state.go(defaultStateToGo);
        }
    };
    LastStateService.prototype.urlToSearchParamsObject = function (url) {
        // @ts-ignore typescript strangely thinks that url.searchParams cannot be passed to Array.from
        return url.searchParams && Array.from(url.searchParams).reduce(function (acc, _a) {
            var k = _a[0], v = _a[1];
            var _b;
            return (__assign({}, acc, (_b = {}, _b[k] = v, _b)));
        }, {});
    };
    LastStateService.prototype.clearLastState = function () {
        this.storage.removeItem('lastState');
    };
    LastStateService.prototype.redirectToLastState = function (lastStateString) {
        if (!isValidJson(lastStateString)) {
            this.$window.location.assign(lastStateString);
            return;
        }
        var lastState = JSON.parse(lastStateString);
        if (lastState.search) // cannot $state.go to Angular2 route with query params
            this.$window.location.assign(lastState.href);
        else
            this.$state.go(lastState.name, lastState.match);
    };
    LastStateService.$inject = ['$localStorage', '$state', '$window', '$urlService'];
    return LastStateService;
}());
export default LastStateService;
